{
  "_note": "Modellunternehmen je Branche, alle Werte pro Mitarbeitendem und Jahr. Vereinfachte Annahmen für die Messe-Demo, keine Branchenstatistik.",
  "energy_factors": {
    "_source": "be2morrow relaunch config/energy_sources.yml (Strommix DE 2025, Erdgas, Diesel)",
    "power_kg_per_kwh": 0.352,
    "heat_kg_per_kwh": 0.20137,
    "fleet_kg_per_litre": 2.6539,
    "upstream_energy_share": 0.17
  },
  "industries": {
    "maschinenbau": {
      "label": "Maschinenbau",
      "tagline": "Sondermaschinen und Anlagen",
      "icon": "gear",
      "revenue_per_employee": 230000,
      "purchase_ratio": 0.5,
      "purchase_split": {
        "metals": 0.38,
        "components": 0.32,
        "plastics": 0.06,
        "packaging": 0.04,
        "services": 0.2
      },
      "logistics_ratio": 0.05,
      "power_kwh": 12000,
      "heat_kwh": 10000,
      "fleet_litre": 250,
      "travel_eur": 1500,
      "commute_t": 0.8,
      "use_phase_t": 40,
      "end_of_life_t": 1.0,
      "waste_t": 0.3,
      "scope12": {
        "sources": {
          "heat": {
            "icon": "🔥",
            "label": "Hallenheizung & Härterei",
            "note": "Scope 1 · Erdgas"
          },
          "fleet": {
            "icon": "🚐",
            "label": "Werksverkehr & Servicefahrzeuge",
            "note": "Scope 1 · Diesel"
          },
          "power": {
            "icon": "⚡",
            "label": "Werkzeugmaschinen & Druckluft",
            "note": "Scope 2 · Netzstrom"
          }
        },
        "insights": {
          "power": "Werkzeugmaschinen und Druckluft laufen oft rund um die Uhr – Strom ist Ihr größter direkter Posten.",
          "heat": "Große Hallen und die Härterei brauchen viel Wärme – das ist Ihr größter direkter Posten.",
          "fleet": "Servicetechniker sind viel unterwegs – der Fuhrpark ist Ihr größter direkter Posten."
        },
        "closing": "Diese Werte stehen auf Ihren Strom- und Gasrechnungen. Aber Ihre Maschinen bestehen aus Stahl – und der kommt von woanders …"
      }
    },
    "kunststoff": {
      "label": "Kunststoff & Chemie",
      "tagline": "Spritzguss und Compounds",
      "icon": "flask",
      "revenue_per_employee": 250000,
      "purchase_ratio": 0.55,
      "purchase_split": {
        "plastics": 0.6,
        "packaging": 0.1,
        "metals": 0.05,
        "components": 0.1,
        "services": 0.15
      },
      "logistics_ratio": 0.06,
      "power_kwh": 25000,
      "heat_kwh": 20000,
      "fleet_litre": 150,
      "travel_eur": 1000,
      "commute_t": 0.8,
      "use_phase_t": 2,
      "end_of_life_t": 8,
      "waste_t": 0.5,
      "scope12": {
        "sources": {
          "heat": {
            "icon": "🔥",
            "label": "Prozesswärme & Trocknung",
            "note": "Scope 1 · Erdgas"
          },
          "fleet": {
            "icon": "🚚",
            "label": "Werksverkehr",
            "note": "Scope 1 · Diesel"
          },
          "power": {
            "icon": "⚡",
            "label": "Spritzguss & Extrusion",
            "note": "Scope 2 · Netzstrom"
          }
        },
        "insights": {
          "power": "Spritzguss und Extrusion sind echte Stromfresser – Strom ist Ihr größter direkter Posten.",
          "heat": "Trocknen und Temperieren brauchen viel Wärme – das ist Ihr größter direkter Posten.",
          "fleet": "Ihr Werksverkehr ist der größte direkte Posten."
        },
        "closing": "Das kennen Sie aus der Energieabrechnung. Ihr Granulat wird allerdings nicht bei Ihnen hergestellt …"
      }
    },
    "lebensmittel": {
      "label": "Lebensmittel",
      "tagline": "Molkerei, Backwaren, Feinkost",
      "icon": "wheat",
      "revenue_per_employee": 280000,
      "purchase_ratio": 0.6,
      "purchase_split": {
        "agri": 0.45,
        "food": 0.3,
        "packaging": 0.15,
        "plastics": 0.05,
        "services": 0.05
      },
      "logistics_ratio": 0.07,
      "power_kwh": 15000,
      "heat_kwh": 25000,
      "fleet_litre": 400,
      "travel_eur": 400,
      "commute_t": 0.8,
      "use_phase_t": 0.5,
      "end_of_life_t": 1.5,
      "waste_t": 1.0,
      "scope12": {
        "sources": {
          "heat": {
            "icon": "🍞",
            "label": "Backöfen, Pasteurisierung & Dampf",
            "note": "Scope 1 · Erdgas"
          },
          "fleet": {
            "icon": "🚚",
            "label": "Kühlfahrzeuge & Auslieferung",
            "note": "Scope 1 · Diesel"
          },
          "power": {
            "icon": "❄️",
            "label": "Kühlung & Abfüllung",
            "note": "Scope 2 · Netzstrom"
          }
        },
        "insights": {
          "power": "Kühlräume und Abfüllung laufen rund um die Uhr – Strom ist Ihr größter direkter Posten, dicht gefolgt von der Prozesswärme.",
          "heat": "Backen, Pasteurisieren und Reinigen brauchen viel Wärme – das ist Ihr größter direkter Posten.",
          "fleet": "Die Kühlkette auf der Straße ist Ihr größter direkter Posten."
        },
        "closing": "So weit, so bekannt. Aber Milch, Getreide und Zutaten stehen auf keiner Energierechnung …"
      }
    },
    "bau": {
      "label": "Bau",
      "tagline": "Hoch- und Tiefbau",
      "icon": "crane",
      "revenue_per_employee": 180000,
      "purchase_ratio": 0.55,
      "purchase_split": {
        "building": 0.45,
        "metals": 0.2,
        "components": 0.05,
        "services": 0.2,
        "goods": 0.1
      },
      "logistics_ratio": 0.04,
      "power_kwh": 3000,
      "heat_kwh": 5000,
      "fleet_litre": 2500,
      "travel_eur": 300,
      "commute_t": 1.2,
      "use_phase_t": 5,
      "end_of_life_t": 2,
      "waste_t": 1.5,
      "scope12": {
        "sources": {
          "heat": {
            "icon": "🔥",
            "label": "Bauhof & Büro",
            "note": "Scope 1 · Erdgas"
          },
          "fleet": {
            "icon": "🚜",
            "label": "Baumaschinen & Fuhrpark",
            "note": "Scope 1 · Diesel"
          },
          "power": {
            "icon": "⚡",
            "label": "Werkstatt & Baustrom",
            "note": "Scope 2 · Netzstrom"
          }
        },
        "insights": {
          "fleet": "Bagger, Kipper und Transporter fahren mit Diesel – der Fuhrpark ist Ihr mit Abstand größter direkter Posten.",
          "heat": "Bauhof und Büro zu heizen ist Ihr größter direkter Posten.",
          "power": "Werkstatt und Baustrom sind Ihr größter direkter Posten."
        },
        "closing": "Beton, Stahl und Ziegel verbauen Sie selbst – hergestellt werden sie aber woanders …"
      }
    },
    "handel": {
      "label": "Handel & Logistik",
      "tagline": "Großhandel und Distribution",
      "icon": "truck",
      "revenue_per_employee": 400000,
      "purchase_ratio": 0.75,
      "purchase_split": {
        "goods": 0.8,
        "packaging": 0.05,
        "food": 0.1,
        "services": 0.05
      },
      "logistics_ratio": 0.03,
      "power_kwh": 8000,
      "heat_kwh": 6000,
      "fleet_litre": 3000,
      "travel_eur": 600,
      "commute_t": 0.8,
      "use_phase_t": 10,
      "end_of_life_t": 3,
      "waste_t": 0.5,
      "scope12": {
        "sources": {
          "heat": {
            "icon": "🔥",
            "label": "Lager- & Bürowärme",
            "note": "Scope 1 · Erdgas"
          },
          "fleet": {
            "icon": "🚛",
            "label": "Lkw-Flotte & Auslieferung",
            "note": "Scope 1 · Diesel"
          },
          "power": {
            "icon": "⚡",
            "label": "Lager, Kühlung & IT",
            "note": "Scope 2 · Netzstrom"
          }
        },
        "insights": {
          "fleet": "Ihre eigene Lkw-Flotte ist der größte direkte Posten – jeder Liter Diesel zählt in Scope 1.",
          "heat": "Große Lagerhallen zu heizen ist Ihr größter direkter Posten.",
          "power": "Lager, Kühlung und IT sind Ihr größter direkter Posten."
        },
        "closing": "Die Waren in Ihrem Lager haben ihren Fußabdruck allerdings schon mitgebracht …"
      }
    },
    "dienstleistung": {
      "label": "Dienstleistung & IT",
      "tagline": "Beratung, Software, Agentur",
      "icon": "laptop",
      "revenue_per_employee": 120000,
      "purchase_ratio": 0.25,
      "purchase_split": {
        "services": 0.65,
        "goods": 0.35
      },
      "logistics_ratio": 0.01,
      "power_kwh": 3000,
      "heat_kwh": 4000,
      "fleet_litre": 300,
      "travel_eur": 3000,
      "commute_t": 1.0,
      "use_phase_t": 0.2,
      "end_of_life_t": 0.1,
      "waste_t": 0.1,
      "scope12": {
        "sources": {
          "heat": {
            "icon": "🏢",
            "label": "Heizung im Büro",
            "note": "Scope 1 · Erdgas"
          },
          "fleet": {
            "icon": "🚗",
            "label": "Dienstwagen",
            "note": "Scope 1 · Kraftstoff"
          },
          "power": {
            "icon": "💻",
            "label": "Büro, Server & Laptops",
            "note": "Scope 2 · Netzstrom"
          }
        },
        "insights": {
          "power": "Büro und Server sind Ihr größter direkter Posten – insgesamt ist Ihr Büro aber eher klein.",
          "heat": "Die Büroheizung ist Ihr größter direkter Posten.",
          "fleet": "Die Dienstwagen sind Ihr größter direkter Posten."
        },
        "closing": "Klein, oder? Aber Flüge, Pendeln und eingekaufte Dienstleistungen stehen auf keiner Energierechnung …"
      }
    }
  }
}
